package top.wcpe.allincore.ui.runtime.ir.call

import top.wcpe.allincore.ui.runtime.ir.DslRuntimeError
import top.wcpe.allincore.ui.runtime.ir.DslValueUtils

/**
 * 跨职责共享的实参提取 / 强转助手（拆分自 [CallDispatcher]）。
 *
 * 仅收纳被多个协作者复用的纯函数：当前为 [toDouble]（同时被
 * [BuiltinCallEvaluator] 的数学 / 颜色内建与 [MemberCallDispatcher] 的
 * `local.warpCursor` 复用）。仅依赖 [DslValueUtils] / [DslRuntimeError] 等已有工具，
 * 处于协作者依赖 DAG 的叶子位置。
 *
 * 注意：仅被单一协作者使用的实参助手（num1 / num2 / numN / stringArg / intArg /
 * longArg / requireArgCount / requireCallable 等）按职责留在各自协作者内部，未上移此处。
 */
@Suppress("MagicNumber")
internal object CallArgs {

    /** 把 DSL 值强转为 double：Number 直转，Boolean 转 0/1，null 视为 0；颜色字符串自动解析。 */
    fun toDouble(funcName: String, v: Any?): Double {
        if (v is Number) return v.toDouble()
        if (v is Boolean) return if (v) 1.0 else 0.0
        if (v == null) return 0.0
        if (v is String) {
            if (v.startsWith("#")) {
                try {
                    val hex = v.substring(1)
                    if (hex.length == 6) return (0xFF000000.toInt() or hex.toInt(16)).toLong().toDouble()
                    if (hex.length == 8) return hex.toLong(16).toInt().toDouble()
                } catch (ignored: NumberFormatException) {
                    // fallthrough
                }
            }
        }
        throw DslRuntimeError("$funcName() 参数必须为数值，实际类型: ${DslValueUtils.classOf(v)}")
    }
}
